import React from 'react';
import Feature from "../utils/Feature";
const FeatureControlledComponent = ({ requireFeature, children }) => {
    if (requireFeature) {
        if (Feature.isEnabled(requireFeature)) {
            return React.createElement(React.Fragment, null, children);
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    }
    else {
        return React.createElement(React.Fragment, null, children);
    }
};
export default FeatureControlledComponent;
//# sourceMappingURL=FeatureControlledComponent.js.map